<div class="main-bg">
  <canvas #liquidCanvas class="liquid-canvas"></canvas>

  <div class="login-container">

    <div class="left">
      <div class="overlay"></div>
      <div class="left-content">
        <div class="icon">
          <svg
            class="icon-svg"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
          </svg>
        </div>

        <h1 class="title">Bienvenido!</h1>
        <div class="divider"></div>

        <p class="description">
         Inicia sesión como administrador para gestionar de manera eficiente los servicios y el funcionamiento del lavado de autos.
        </p>

      </div>
    </div>

    <div class="right">
      <div class="right-content">
        <img class="logoEspacio" src="assets/logo.jpeg" alt="logo" loading="lazy">
        <h2 class="login-title">Inicia Sesión</h2>
        <div class="login-divider"></div>

        <div *ngIf="errorMessage" class="server-error">
          {{ errorMessage }}
        </div>

        <form class="form" #loginForm="ngForm" (ngSubmit)="login(loginForm, $event)">

          <div class="form-group">
            <label class="label" for="username">Usuario (Correo)</label>
            <input 
              id="username" 
              name="username" 
              type="email"
              [(ngModel)]="username" 
              #usernameModel="ngModel"
              required 
              email 
              placeholder="usuario@ejemplo.com" 
              class="input" 
              [class.input-error]="usernameModel.invalid && usernameModel.touched" 
            />
            
            <div *ngIf="usernameModel.invalid && usernameModel.touched" class="error-text">
              <small *ngIf="usernameModel.errors?.['required']">
                El correo es obligatorio.
              </small>
              <small *ngIf="usernameModel.errors?.['email']">
                Debes ingresar un correo válido (ejemplo: usuario@dominio.com).
              </small>
            </div>
          </div>

          <div class="form-group">
            <label class="label" for="password">Contraseña</label>
            <div class="password-input-wrapper">
              <input id="password" name="password"
                [type]="showPassword ? 'text' : 'password'"
                [(ngModel)]="password" #passwordModel="ngModel"
                required minlength="4" placeholder="••••••••" class="input password-input"
                [class.input-error]="passwordModel.invalid && passwordModel.touched"
                autocomplete="current-password"
                style="width: 100%; padding-right: 38px;" />
              <button type="button"
                (click)="toggleShowPassword()"
                class="eye-toggle-btn"
                tabindex="0">
                <ng-container *ngIf="!showPassword">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#888"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></svg>
                </ng-container>
                <ng-container *ngIf="showPassword">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#888"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.956 9.956 0 012.293-3.95m3.362-2.522A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.97 9.97 0 01-4.293 5.03M15 12a3 3 0 11-6 0 3 3 0 016 0zm-6.364 6.364L19.07 4.93"/></svg>
                </ng-container>
              </button>
            </div>
            <div *ngIf="passwordModel.invalid && passwordModel.touched" class="error-text">
              <small *ngIf="passwordModel.errors?.['required']">La contraseña es obligatoria.</small>
            </div>
          </div>

          <button type="submit" class="btn-login" [disabled]="loginForm.invalid">Ingresar</button>
          <button type="button" class="btn-regresar" (click)="goBack()">Regresar</button>

        </form>

        
      </div>
    </div>
  </div>
</div>